import { filterMealtimesWithCategories } from './filterMealtimesWithCategories';

export default filterMealtimesWithCategories;
